module.exports = __webpack_public_path__ + "static/img/haibao.ed316f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/match/haibao.jpg
// module id = Gu+U
// module chunks = 10